/**
 * PC では html に scroll-padding-top を付けており、scrollIntoView が固定ヘッダー分を考慮する。
 * window.scrollTo で手動オフセットすると #main の padding-top と二重になり上に寄りすぎるため使わない。
 */

/** slick 初期化・setPosition 後にレイアウトが落ち着くまで待つ（Pages の .slick-carousel 用） */
export const PAGES_SLICK_ANCHOR_DELAY_MS = 320;

export const HOME_ALIGNMENT_HASH = '#home-alignment';
export const HOME_ALIGNMENT_ID = 'home-alignment';

export function scrollElementIntoViewBelowFixedHeader(
  el: HTMLElement,
  behavior: ScrollBehavior = 'smooth'
): void {
  el.scrollIntoView({ block: 'start', behavior });
}

export function scrollToHomeAlignmentAnchor(
  behavior: ScrollBehavior = 'smooth'
): boolean {
  const el = document.getElementById(HOME_ALIGNMENT_ID);
  if (!el) {
    return false;
  }
  scrollElementIntoViewBelowFixedHeader(el, behavior);
  return true;
}
